if (typeof window.AEStickyProductBar !== 'function') {
  class AEStickyProductBar extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.button = this.querySelector('[data-ae-sticky-cta]');
      this.action = this.dataset.ctaAction || 'scroll';
      this.targetSelector = this.dataset.targetSelector || '[data-ae-product-form]';
      this.showWhen = this.dataset.showWhen || 'after_hero';
      this.scrollThreshold = parseInt(this.dataset.scrollThreshold || '400', 10);

      this.setupVisibility();
      this.setupCta();
      this.correctDeliveryDay();
    }

    correctDeliveryDay() {
      const els = this.querySelectorAll('[data-ae-day]');
      if (!els.length) return;
      try {
        const fmtH = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: 'numeric', hour12: false });
        const fmtW = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'long' });
        const now = new Date();
        const wd = fmtW.format(now);
        const h = parseInt(fmtH.format(now), 10);
        let name;
        if (wd === 'Saturday' || wd === 'Sunday' || (wd === 'Friday' && h >= 14)) {
          name = 'Tuesday';
        } else {
          name = fmtW.format(new Date(now.getTime() + (h < 14 ? 1 : 2) * 86400000));
        }
        els.forEach((el) => {
          const served = el.getAttribute('data-ae-day');
          if (served && served !== name) el.innerHTML = el.innerHTML.split(served).join(name);
        });
      } catch (e) { /* keep server-rendered day */ }
    }

    setupVisibility() {
      const target = document.querySelector(this.targetSelector);

      if (this.showWhen === 'after_hero' && target && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.hide();
            } else {
              const rect = entry.boundingClientRect;
              if (rect.bottom <= 0) {
                this.show();
              } else {
                this.hide();
              }
            }
          });
        }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });

        this.observer.observe(target);
        this.removeAttribute('hidden');
        return;
      }

      this.onScroll = () => {
        if (window.scrollY >= this.scrollThreshold) {
          this.show();
        } else {
          this.hide();
        }
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.removeAttribute('hidden');
      this.onScroll();
    }

    setupCta() {
      if (!this.button) return;

      this.button.addEventListener('click', (event) => {
        if (this.action === 'add_to_cart') {
          event.preventDefault();
          const variantId = this.button.getAttribute('data-variant-id');
          if (!variantId) return;
          if (typeof window.ancientAddToCart === 'function') {
            const opts = { button: this.button };
            const plan = this.button.getAttribute('data-default-selling-plan');
            if (plan) opts.sellingPlan = plan;
            window.ancientAddToCart(variantId, opts);
          }
          return;
        }

        const target = document.querySelector(this.targetSelector);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        // V2 hero pages have no scroll target: add the shopper's current selection via the hero ATC
        const v2Atc = document.querySelector('[data-phv2-atc]');
        if (v2Atc) {
          event.preventDefault();
          v2Atc.click();
        }
      });
    }

    show() {
      this.setAttribute('data-visible', '');
    }

    hide() {
      this.removeAttribute('data-visible');
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }
  }

  window.AEStickyProductBar = AEStickyProductBar;
  customElements.define('ae-sticky-product-bar', AEStickyProductBar);
}
